export default __webpack_public_path__ + "static/media/hotel.16bcab62.png";